module.exports = __webpack_public_path__ + "media/images/icons/alignment-254d9799af536d10f1a89ac20669c261.png";